fx.ns("repositories", class PhotoFiltersRepository extends fx.ModelArray {

    constructor()
	{
		super([]);
	}
});